module.exports = __webpack_public_path__ + "img/militaryStatus.071b17a8.svg";